var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluePrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#5b8dc9;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:#42455e;}.cls-9{fill:#fff;}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 28.99,
    x2: 11,
    y2: 28.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7aa8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3d2e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 38,
    x2: 63,
    y2: 38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 40,
    y1: 7,
    x2: 40,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9a254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4bb79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 54,
    y1: 7,
    x2: 54,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0a6ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6ccda"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 59.5,
    y1: 7,
    x2: 59.5,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d96bb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e49fc6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 17,
    y1: 4,
    x2: 24,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2c4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe3d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 24,
    y1: 28,
    x2: 24,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcc88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe5c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 50,
    x2: 50,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 50,
    y1: 42,
    x2: 50,
    y2: 34,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 50,
    y1: 56,
    x2: 50,
    y2: 48,
    xlinkHref: "#linear-gradient-7"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Blue Print") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blue_Print",
    "data-name": "Blue Print"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,1V51H7a6,6,0,0,0-6,6V7A5.94,5.94,0,0,1,2.76,2.76C4.88.62,7,1,11,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63,13V63H7A6,6,0,0,1,2.76,52.76C4.88,50.62,7,51,11,51V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,61v2H7a6,6,0,0,1-5.91-7A6,6,0,0,0,7,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,49v2H7a6,6,0,0,0-5.91,5,5.94,5.94,0,0,1,1.67-5.24C4.88,48.62,7,49,11,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63,3V5a2,2,0,0,1-2,2H23L17,4l6-3H61A2,2,0,0,1,63,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 52,
    y: 1,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63,3V5a2,2,0,0,1-2,2H56V1h5A2,2,0,0,1,63,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M23.27,7c-.39,0,.39.33-6.27-3,6.65-3.33,5.88-3,6.27-3A6.55,6.55,0,0,1,23.27,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M19.84,5.42,17,4l2.84-1.42A6.33,6.33,0,0,1,19.84,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43,39H24a1,1,0,0,1-1-1V28a1,1,0,0,1,2,0v9H43A1,1,0,0,1,43,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43,53H37a1,1,0,0,1-1-1V24a1,1,0,0,1,1-1h6a1,1,0,0,1,0,2H38V51h5A1,1,0,0,1,43,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,47H21a1,1,0,0,1,0-2H32A1,1,0,0,1,32,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,52H21a1,1,0,0,1,0-2H32A1,1,0,0,1,32,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,57H21a1,1,0,0,1,0-2H32A1,1,0,0,1,32,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18,46a1,1,0,0,1-2,0A1,1,0,0,1,18,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18,51a1,1,0,0,1-2,0A1,1,0,0,1,18,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18,56a1,1,0,0,1-2,0A1,1,0,0,1,18,56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 17,
    y: 20,
    width: 14,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 43,
    y: 20,
    width: 14,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 43,
    y: 34,
    width: 14,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 43,
    y: 48,
    width: 14,
    height: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePrint);
export default __webpack_public_path__ + "static/media/Blue Print.c737df6d9e62b9815c269db6415dfef1.svg";
export { ForwardRef as ReactComponent };